"use client";
import {
  createCompositeStore
} from "../__chunks/VH2P7HEP.js";
import "../__chunks/I2WJ7JBQ.js";
import "../__chunks/7PRQYBBV.js";
import "../__chunks/KLPDXTDE.js";
import {
  defaultValue
} from "../__chunks/22HHDS5F.js";
import "../__chunks/I2NJJ3XW.js";
import {
  __spreadProps,
  __spreadValues
} from "../__chunks/4R3V3JGP.js";

// src/toolbar/toolbar-store.ts
function createToolbarStore(props = {}) {
  var _a;
  const syncState = (_a = props.store) == null ? void 0 : _a.getState();
  return createCompositeStore(__spreadProps(__spreadValues({}, props), {
    orientation: defaultValue(
      props.orientation,
      syncState == null ? void 0 : syncState.orientation,
      "horizontal"
    ),
    focusLoop: defaultValue(props.focusLoop, syncState == null ? void 0 : syncState.focusLoop, true)
  }));
}
export {
  createToolbarStore
};
